import { Instance } from 'flatpickr/dist/types/instance';
import { DateInputControllerData, DateInputFieldData } from './type/date';
import flatpickr from 'flatpickr';
import { ValidDateRangeSchema } from '../../../../shared/validate/dateValidators';
import { Korean } from 'flatpickr/dist/l10n/ko.js';
import { english } from 'flatpickr/dist/l10n/default.js';
import { CustomEventWithDetail } from 'rune-ts';
import { DateInputView } from '../BaseInput/views/DateInputView';

export class onCalendarChangeEvent extends CustomEventWithDetail<{
  value: Date | undefined;
}> {}

export class DateInputCalendarController {
  private picker: Instance | null = null;
  private readonly dateInputView: DateInputView;
  private readonly data: DateInputControllerData;

  constructor(dateInputView: DateInputView, data: DateInputControllerData) {
    this.data = data;
    this.dateInputView = dateInputView;
  }

  public init(): void {
    if (this.picker) {
      console.warn('DateInputCalendarController: already initialized');
      return;
    }

    const inputElement = this.dateInputView.element();

    if (!(inputElement instanceof HTMLElement)) {
      console.error('DateInputCalendarController: element() did not return an element.');
      return;
    }

    this.picker = flatpickr(inputElement, {
      locale: this.getLocale(),
      static: true,
      allowInput: false,
      enableTime: true,
      enableSeconds: true,
      defaultHour: 0,
      defaultDate: this.dateInputView.getValue(),
      minDate: this.data.range?.min,
      maxDate: this.data.range?.max,
      disableMobile: true,
      onValueUpdate: ([date]) => {
        this.dateInputView.setValueAndSync(date);
        this.dateInputView.dispatchEvent(onCalendarChangeEvent, {
          bubbles: true,
          detail: {
            value: date,
          },
        });
      },
      onReady: (_, _date_str, instance) => {
        instance.close();
      },
    });
  }

  public open() {
    if (this.picker) {
      this.picker.open();
    }
  }

  public close() {
    if (this.picker) {
      this.picker.close();
    }
  }

  public destroy() {
    if (this.picker) {
      this.picker.destroy();
    }
  }

  public static validateDateRange(range: DateInputFieldData['range']) {
    if (!range) {
      return;
    }
    ValidDateRangeSchema.safeParse({
      start: range.min,
      end: range.max,
    });
  }

  private getLocale() {
    return this.data.locale === 'kr' ? Korean : english;
  }
}
